import type { User } from "@/lib/api/types";

export function isAdmin(user: User | null | undefined): boolean {
  return user?.role === "admin";
}

export function isManager(user: User | null | undefined): boolean {
  return user?.role === "manager";
}

export function isAdminOrManager(user: User | null | undefined): boolean {
  return user?.role === "admin" || user?.role === "manager";
}
